// Force release 2026-10-21
import { bootstrap } from './bootstrap';

bootstrap();
